import Events from "../utils/Events.js";
import NuCalBaseView from "./NuCalBaseView.js";

/**
 * @extends NuCalBaseView
 * @param {Object} props properties.
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 * @param {Function(date)} props.renderTemplate A custom function that renders the template.
 */

class NuCalPrettyView extends NuCalBaseView {

	constructor(props){
		super(props);
		this.classPrefix = props.classPrefix || "cp-nuCalPrettyView";
		this.renderTemplate = (props.renderTemplate instanceof Function)? props.renderTemplate : this._defaultRenderTemplate;
		this.view.classList.add(`${this.classPrefix}`);
	}

	subscribe(){
		this._subscriptions.push(
			Events.subscribe( this._events.datesUpdated ,this.render.bind(this) )
		);
	}

	render(props){
		let date;
		if(this.dateType === "arrival"){
			date = props.arrivalDate;
		}else{
			date = props.departureDate;
		}
		this.renderTemplate(date);
	}

	_defaultRenderTemplate(date){
		this.view.innerHTML = `
        <span class="${this.classPrefix}-date">
            ${date.toLocaleDateString(this.locale,{ "day": "2-digit" })}
        </span>
        <span class="${this.classPrefix}-day after-arrow">${date.toLocaleDateString(this.locale,{ "weekday": "short" })}</span>
        <span class="${this.classPrefix}-month">${date.toLocaleDateString(this.locale,{ "month": "long" })}</span>
    `;
	}
}

export default NuCalPrettyView;